module.exports = __webpack_public_path__ + "static/img/bn.62e7e8c1.svg";